import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowLeft = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.35355 18.3536C9.15829 18.5488 8.84171 18.5488 8.64645 18.3536L2.64645 12.3536C2.45119 12.1583 2.45119 11.8417 2.64645 11.6464L8.64645 5.64645C8.84171 5.45118 9.15829 5.45118 9.35355 5.64645C9.54882 5.84171 9.54882 6.15829 9.35355 6.35355L4.20711 11.5L20.5 11.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5L4.20711 12.5L9.35355 17.6464C9.54882 17.8417 9.54882 18.1583 9.35355 18.3536Z"
      />
    </svg>
  )
})

export default ArrowLeft
